// The corsis_login cookie is set server-side by the Warden hook in
// config/initializers/analytics_login_beacon.rb at every genuine sign-in
// (password, OAuth, GraphQL). Reading it here — on the full page load that
// always follows login — is how the frontend attributes user_signed_in events.
const BEACON_COOKIE = "corsis_login";

export function consumeLoginBeacon(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${BEACON_COOKIE}=([^;]*)`));
  if (!match) return null;
  document.cookie = `${BEACON_COOKIE}=; path=/; max-age=0`;
  // The cookie is cleared above before decoding, so a malformed value (only
  // reachable via client-side tampering — the server always writes clean
  // method strings) can't crash boot or persist to the next page load.
  let method = "";
  try {
    method = decodeURIComponent(match[1]);
  } catch {
    return null;
  }
  return method === "" ? null : method;
}
